import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {OrgProfileContainerComponent} from './components/org-profile-container/org-profile-container.component';

const routes: Routes = [
  {path: 'profile/:orgId', component: OrgProfileContainerComponent},
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class OrganisationRoutingModule {
}
